<template>
    <el-table
        :data="tableData"
        style="width: 100%"
        :cell-style="{
            'font-size': '16px',
            color: '#333',
        }"
        :header-cell-style="{
            'background-color': '#d7d7d7',
            'font-weight': '700',
            color: '#333',
            'font-size': '16px',
        }"
    >
        <el-table-column
            label="批次号/班级编码"
            prop="type"
            align="center"
            header-align="center"
        >
            <template slot-scope="scope">
                <div style="color: #409eff">
                    {{ scope.row.type }}
                </div>
            </template>
        </el-table-column>
        <el-table-column
            label="课程状态"
            prop="total"
            align="center"
            header-align="center"
        >
        </el-table-column>
        <el-table-column
            label="任课老师"
            prop="signingUp"
            align="center"
            header-align="center"
        >
        </el-table-column>
        <el-table-column
            label="学习人数"
            prop="learning"
            align="center"
            header-align="center"
        >
        </el-table-column>
        <el-table-column
            label="平均分"
            prop="notLearn"
            align="center"
            header-align="center"
        ></el-table-column>
        <el-table-column
            label="合格占比"
            prop="studyOver"
            align="center"
            header-align="center"
        ></el-table-column>
        <el-table-column
            label="良好占比"
            prop="learnNum"
            align="center"
            header-align="center"
        ></el-table-column>
        <el-table-column
            label="优秀占比"
            prop="studyNum"
            align="center"
            header-align="center"
        ></el-table-column>
        <el-table-column
            label="不合格占比"
            prop="studyNum"
            align="center"
            header-align="center"
        ></el-table-column>
        <el-table-column
            label="最高分"
            prop="studyNum"
            align="center"
            header-align="center"
        ></el-table-column>
        <el-table-column
            label="最低分"
            prop="studyNum"
            align="center"
            header-align="center"
        ></el-table-column>
    </el-table>
</template>

<script>
export default {
    props: ["tableData"],
    methods: {},
};
</script>

